import classNames from "classnames";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportOwnersProps } from "./types";
import classes from "./report-owners.module.scss";

export const ReportOwners = ({ owners, isPdfMode = false }: ReportOwnersProps) => {
    return (
        <div className={classes.owners}>
            <ul className={classes.owners__list}>
                {owners.map((item, index) => {
                    const lineClass = classNames(classes.owners__line, {
                        [classes["owners__line--inactive"]]: item.title === "Без регистрации"
                    });

                    const pointClass = classNames(classes.owners__point, {
                        [classes["owners__point--inactive"]]: item.title === "Без регистрации"
                    });

                    const title = (
                        <div className={classes.owners__header}>
                            {item.title}
                            <div className={classes.owners__date}>{item.period}</div>
                        </div>
                    );

                    const content = (
                        <div className={classes.owners__content}>
                            <div className={classes.owners__date}>{item.region}</div>
                        </div>
                    );

                    return (
                        <li key={index} className={classes.owners__item}>
                            <div className={lineClass} />
                            <div className={pointClass} />
                            {item.region ? (
                                <FixedAccordion
                                    title={title}
                                    content={content}
                                    expanded={isPdfMode}
                                />
                            ) : (
                                title
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};